import styled from "@emotion/styled";
import { TextField } from "@mui/material";

export const TextFieldWrapper = styled(TextField)({
  margin: "16px 0px 16px 0px",
});
export const TextFieldHorizontalWrapper = styled(TextField)({
  margin: "16px 16px 16px 0px",
});
